import { makeStyles, Theme } from '@material-ui/core/styles'
import { BorderRadius } from '@styled-icons/boxicons-regular'

export const useStyles = makeStyles<Theme>((theme) => ({
  promoImg: {
    width: '100%',
    marginBottom: '3.5rem'
  },
  tabTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: 8,
    color: theme.palette.text.secondary
  },
  contentContainer: {
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: 32
  },
  paragraph: {
    marginBottom: 16,
    fontSize: '1rem',
    lineHeight: 1.7,
    color: theme.palette.text.primary
  },
  separator: {
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.divider,
    margin: '32px 0'
  },
  cardGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: 32,
    width: '100%',
    flexWrap: 'wrap',
    marginTop: 24
  },
  card: {
    flex: 1,
    minWidth: 260,
    padding: '32px 24px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 16,
    border: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  },
  cardTitle: {
    fontFamily: 'Rubik',
    fontWeight: 700,
    fontSize: '1.4rem',
    lineHeight: 1.3,
    color: '#2c3e51',
    marginBottom: 16
  },
  cardText: {
    fontSize: '0.95rem',
    lineHeight: 1.6,
    color: theme.palette.text.secondary,
    marginBottom: 24
  },
  buttonContainer: {
    marginBottom: 8,
    width: '100%',
    gap: 8
  },
  buttonLink: {
    textDecoration: 'none'
  },
  button: {
    backgroundColor: theme.palette.primary.contrastText,
    borderRadius: '30px',
    minHeight: '45px',
    padding: '0 24px',
    textTransform: 'none',

    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  }
}))
